import { useState } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const ContactForm = () => {
  const [formState, setFormState] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsSubmitting(true);

    try {
      await addDoc(collection(db, 'contact_us'), {
        ...formState,
        createdAt: serverTimestamp(),
      });

      window.alert('Thank you for contacting MyFundz! We will get back to you shortly.');
      setFormState({
        name: '',
        phone: '',
        email: '',
        service: '',
        message: '',
      });
    } catch (error) {
      window.alert('Sorry, your message could not be sent right now. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form fade-in">
      <form id="contactForm" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">Your Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your name"
              required
              value={formState.name}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Your Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="+91-"
              required
              value={formState.phone}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="email">Your Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="yourname@gmail.com"
            required
            value={formState.email}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="service">Services</label>
          <select
            id="service"
            name="service"
            required
            value={formState.service}
            onChange={handleChange}
          >
            <option value="">Choose services</option>
            <option value="mutual-funds">Mutual Fund Advisory – SIP & Lump Sum</option>
            <option value="pms">Portfolio Management Services (PMS)</option>
            <option value="retirement">Retirement Planning (NPS & Bonds)</option>
            <option value="insurance">Insurance Planning</option>
            <option value="corporate-deposits">Corporate Deposits</option>
            <option value="loan-against-mf">Loan Against Mutual Funds</option>
            <option value="postal-savings">Postal Savings Services</option>
            <option value="portfolio-review">Portfolio Review & Rebalancing</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Your message"
            required
            value={formState.message}
            onChange={handleChange}
          ></textarea>
        </div>
        <button type="submit" className="submit-btn" disabled={isSubmitting}>
          {isSubmitting ? 'Sending...' : 'Send message'}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
